import { atcClassificationsActions } from '../actions'
import ValidateFormObject from '../utils/ValidateFormObject'
const {
  FETCH_ATCCLASSIFICATION,
  FETCHING_ATCCLASSIFICATION,
  FETCH_ATCCLASSIFICATION_ERROR,
  FETCH_ATCCLASSIFICATIONS,
  FETCHING_ATCCLASSIFICATIONS,
  FETCH_ATCCLASSIFICATIONS_ERROR,
  OPEN_MODAL,
  CLOSE_MODAL,
  CHANGE_ATCCLASSIFICATION,
  DELETE_ATCCLASSIFICATION,
  ADD_ATCCLASSIFICATION,
  EDIT_ATCCLASSIFICATION,
  FORM_TOUCHED,
  NEW_FORM_ATCCLASSIFICATION,
  CHANGE_PAGE,
  CHANGE_PER_PAGE,
  CHANGE_ORDER_COLUMN,
  CHANGE_ORDER_DIRECTION,
  ATCCLASSIFICATION_FORM_ERROR,
  RESET_STATE
} = atcClassificationsActions

const initialState = {
  loadingAtcClassification: false,
  loadingAtcClassifications: false,
  fetchAtcClassificationError: false,
  fetchAtcClassificationsError: false,
  atcClassifications: [],
  order: {
    column: 'nome',
    direction: 1
  },
  atcClassification: {
    nome: '',
    atc: false
  },
  atcClassificationsPagination: {
    page: 0,
    rowsPerPage: 50,
    length: 0
  },
  atcClassificationFormErrors: {},
  atcClassificationFormTouched: false,
  modalOpen: false
}

const atcClassificationSchema = {
  add: {
    nome: {
      required: true,
      minValue: 3
    }
  },
  edit: {
    nome: {
      required: true,
      minValue: 3
    }
  }
}

const AtcClassificationValidate = new ValidateFormObject(atcClassificationSchema)

const atcClassifications = (state = initialState, action = {}) => {
  let formSchemaType
  switch (action.type) {
    case CHANGE_ATCCLASSIFICATION:
      formSchemaType = action.atcClassification._id ? 'edit' : 'add'
      return {
        ...state,
        atcClassification: action.atcClassification,
        atcClassificationFormErrors: AtcClassificationValidate.validate({
          formObject: action.atcClassification,
          formSchemaType
        })
      }
    case ATCCLASSIFICATION_FORM_ERROR:
      const formErrors = {}
      formSchemaType = state.atcClassification._id ? 'edit' : 'add'
      formErrors[action.field] = { valid: false, errorMessage: action.message }
      return {
        ...state,
        atcClassificationFormErrors: AtcClassificationValidate.validate({
          formObject: state.atcClassification,
          invalidFields: formErrors,
          formSchemaType
        })
      }
    case NEW_FORM_ATCCLASSIFICATION:
      return {
        ...state,
        atcClassification: { ...initialState.atcClassification },
        atcClassificationFormErrors: AtcClassificationValidate.validate({}),
        atcClassificationFormTouched: false
      }
    case FORM_TOUCHED:
      return {
        ...state,
        atcClassificationFormTouched: true
      }
    case OPEN_MODAL:
      return {
        ...state,
        modalOpen: true
      }
    case CLOSE_MODAL:
      return {
        ...state,
        modalOpen: false
      }
    case FETCH_ATCCLASSIFICATION:
      formSchemaType = (action.atcClassification || {})._id ? 'edit' : 'add'
      return {
        ...state,
        atcClassification: action.atcClassification,
        loadingAtcClassification: false,
        fetchAtcClassificationError: false,
        atcClassificationFormTouched: false,
        atcClassificationFormErrors: AtcClassificationValidate.validate({
          formObject: action.atcClassification,
          formSchemaType
        })
      }
    case FETCHING_ATCCLASSIFICATION:
      return {
        ...state,
        loadingAtcClassification: true,
        fetchAtcClassificationError: false
      }
    case DELETE_ATCCLASSIFICATION:
      return {
        ...state,
        loadingAtcClassifications: false,
        fetchAtcClassificationError: false,
        atcClassifications: state.atcClassifications.map(atcClassification => {
          if (atcClassification._id === (action.atcClassification || {})._id) {
            return action.atcClassification
          }
          return atcClassification
        })
      }
    case FETCH_ATCCLASSIFICATION_ERROR:
      return {
        ...state,
        loadingAtcClassifications: false,
        atcClassification: { ...initialState.atcClassification },
        fetchAtcClassificationError: action.error
      }
    case CHANGE_ORDER_COLUMN:
      return {
        ...state,
        order: {
          direction: 1,
          column: action.column
        }
      }
    case CHANGE_ORDER_DIRECTION:
      return {
        ...state,
        order: {
          ...state.order,
          direction: action.direction
        }
      }
    case CHANGE_PAGE:
      return {
        ...state,
        atcClassificationsPagination: {
          ...state.atcClassificationsPagination,
          page: action.page
        }
      }
    case CHANGE_PER_PAGE:
      return {
        ...state,
        atcClassificationsPagination: {
          ...state.atcClassificationsPagination,
          rowsPerPage: action.perPage
        }
      }
    case FETCH_ATCCLASSIFICATIONS:
      return {
        ...state,
        loadingAtcClassifications: false,
        atcClassifications: action.atcClassifications,
        fetchAtcClassificationsError: false,
        order: action.order,
        atcClassificationsPagination: {
          length: action.length,
          page: action.page,
          rowsPerPage: action.rowsPerPage
        }
      }
    case EDIT_ATCCLASSIFICATION:
      return {
        ...state,
        atcClassifications: state.atcClassifications.map(atcClassification => {
          if (atcClassification._id === action.atcClassification._id) {
            return action.atcClassification
          }
          return atcClassification
        }),
        loadingAtcClassifications: false,
        fetchAtcClassificationError: false,
        loadingAtcClassification: false,
        fetchAtcClassificationsError: false
      }
    case FETCHING_ATCCLASSIFICATIONS:
      return {
        ...state,
        loadingAtcClassifications: true,
        fetchAtcClassificationsError: false
      }
    case FETCH_ATCCLASSIFICATIONS_ERROR:
      return {
        ...state,
        loadingAtcClassifications: false,
        fetchAtcClassificationsError: action.error,
        loadingAtcClassification: false
      }
    case ADD_ATCCLASSIFICATION:
      return {
        ...state,
        loadingAtcClassifications: false,
        fetchAtcClassificationsError: false,
        loadingAtcClassification: false,
        atcClassifications: [...state.atcClassifications, action.atcClassification]
      }
    case RESET_STATE:
      return initialState
    default:
      return state
  }
}

export default atcClassifications



// WEBPACK FOOTER //
// ./src/reducers/atcClassifications.js